module.exports = __webpack_public_path__ + "static/media/compass.ad305de5.svg";